var _classCallCheck = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var core = require('@sentry/core');
var featureFlags = require('../../../utils/featureFlags.js');
var openFeatureIntegration = core.defineIntegration(function () {
  return {
    name: 'OpenFeature',
    processEvent: function processEvent(event, _hint, _client) {
      return featureFlags.copyFlagsFromScopeToEvent(event);
    }
  };
});

/**
 * OpenFeature Hook class implementation.
 */
var OpenFeatureIntegrationHook = /*#__PURE__*/function () {
  "use strict";

  function OpenFeatureIntegrationHook() {
    _classCallCheck(this, OpenFeatureIntegrationHook);
  }
  return _createClass(OpenFeatureIntegrationHook, [{
    key: "after",
    value:
    /**
     * Successful evaluation result.
     */
    function after(_hookContext, evaluationDetails) {
      featureFlags.insertFlagToScope(evaluationDetails.flagKey, evaluationDetails.value);
    }

    /**
     * On error evaluation result.
     */
  }, {
    key: "error",
    value: function error(hookContext, _error, _hookHints) {
      featureFlags.insertFlagToScope(hookContext.flagKey, hookContext.defaultValue);
    }
  }]);
}();
exports.OpenFeatureIntegrationHook = OpenFeatureIntegrationHook;
exports.openFeatureIntegration = openFeatureIntegration;